// extracted by mini-css-extract-plugin
export var integrationButton = "_al-0";